import React, {Component} from "react";
import FlexView from "react-flexview";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleInput from "../../../../modules/SimpleInput";
import Api from "../../../../Services/Api";
import BarangLainTab from "./barangLainTab";
import CekFisikUnitTab from "./cekFisikUnitTab";
import FotoTab from "./fotoTab";
import HadiahTab from "./hadiahTab";
import KsuTab from "./ksuTab";
import PartTab from "./partTab";
import {HttpStatus, PDIStatus} from "../../../common/Constants";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import {contructQueryParam, fetchDataAsync} from "../../../../Services/Utils";
import * as R from "ramda";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";

class FormDetailPDI extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: false,
            confirmTolakVisible: false,
            errorPhoto: false,
            barcodeUsed: {
                ksuBarcode: [],
                giftBarcode: [],
                otherBarcode: [],
                partBarcode: [],
                visible: false,
            },
        };
    }

    async componentDidMount() {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getPDIById,
            setError: this.props.setError,
            menuName: "Belum PDI",
            args: this.props.id,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                data: res.data.data,
            }));
        } else {
            this.props.onClickClose("");
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    }

    handleChangePhysical = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                physicalCheck: {
                    ...prevValue.data.physicalCheck,
                    [name]: value.value,
                },
            },
        }));
    };

    handleChangeTableStatus = (dataName, index, fieldName, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                [dataName]: prevValue.data[dataName].map((d, idx) =>
                    index === idx ? {...d, [fieldName]: value} : d
                ),
            },
        }));
    };

    handleChangeImage = (value, name) => {
        this.setState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                [name]: value,
            },
        }));
    };

    handleRefresh = async () => {
        this.handleTriggerLoading();
        const res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").refreshPDIAndExpedition,
            setError: this.props.setError,
            menuName: "Belum PDI",
            args: contructQueryParam({pdiNo: this.state.data.pdiNo}),
        });
        if (res?.ok && res.data.status === HttpStatus.SUCCESS) {
            const {ksu, giftBarcode, otherItemBarcode, partBarcode} = res.data.data;
            this.setState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    ksu: this.updateBarcode(prevValue.data.ksu, ksu, "ksuCode", "ksuBarcode", "ksuBarcodeEncrypted"),
                    giftBarcode: this.updateBarcode(prevValue.data.giftBarcode, giftBarcode, "giftCode", "giftBarcode", "giftBarcodeEncrypted"),
                    otherItemBarcode: this.updateBarcode(prevValue.data.otherItemBarcode, otherItemBarcode, "otherItemCode", "otherItemBarcode", "otherItemBarcodeEncryted"),
                    partBarcode: this.updateBarcode(prevValue.data.partBarcode, partBarcode, "partCode", "partBarcode", "partBarcodeEncrypted"),
                }
            }));
        }
        this.handleTriggerLoading();
    };

    updateBarcode = (dataArray, dataList, codeKey, barcodeKey, encryptedKey) => {
        return dataArray.map((data) => {
            if (R.isNil(data[barcodeKey]) || R.isEmpty(data[barcodeKey])) {
                const foundItem = dataList.find(item => item.id === data.id);
                return foundItem ? {
                    ...data,
                    [barcodeKey]: foundItem?.[barcodeKey],
                    [encryptedKey]: foundItem?.[encryptedKey],
                } : data;
            }
            return data;
        });
    }

    handleUpdateStatus = async (status) => {
        this.setState({ loading: true});
        const data = this.state.data;
        if (data.engineNumberPhoto === null && status !== PDIStatus.TOLAK) {
            this.setState({ showErrors: true, loading: false });
            this.handleAlertModalSaveVisibility();
            return;
        }

        if (status === PDIStatus.SELESAI) {
            let req = this.extractBarcode(data);
            const res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").checkStatusBarcodeBulk,
                setError: this.props.setError,
                menuName: "Belum PDI",
                args: req,
            });
            if (!res?.ok || res?.data?.status !== HttpStatus.SUCCESS || !res?.data?.data) {
                this.setState({ loading: false });
                return;
            }
            if (this.showBarcodeError(res.data.data)) {
                this.setState({ loading: false});
                return;
            }
        }

        const request = {
            kodeCabang: data.cabang.kodeCabang,
            pdiNo: data.pdiNo,
            pdiStatus: status,
            idType: data.type.id,
            variantCode: data.warna.kodeVariant,
            idWarna: data.warna.id,
            engineNumber: data.engineNumber,
            frameNumber: data.frameNumber,
            salesFakturNo: data.salesFakturNo,
            notes: data.pdiNote,
            physicalCheck: data.physicalCheck,
            ksu: data.ksu,
            gift: data.gift,
            giftBarcode: data.giftBarcode,
            otherItem: data.otherItem,
            otherItemBarcode: data.otherItemBarcode,
            part: data.part,
            partBarcode: data.partBarcode,
            engineNumberPhoto: data.engineNumberPhoto,
            frameNumberPhoto: data.frameNumberPhoto,
        };

        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").modifyPDI,
            setError: this.props.setError,
            menuName: "Belum PDI",
            args: request,
        });

        if (response.ok) {
            this.props.onClickClose(null);
        }


        this.setState({ loading: false});
    };

    extractBarcode = (body) => {
        return {
            pdiNo: body.pdiNo,
            ksuBarcode: this.getBarcode(body.ksu, "ksuBarcode"),
            giftBarcode: this.getBarcode(body.giftBarcode, "giftBarcode"),
            otherBarcode: this.getBarcode(body.otherItemBarcode, "otherItemBarcode"),
            partBarcode: this.getBarcode(body.partBarcode, "partBarcode"),
        }
    }

    getBarcode = (list, key) => {
        return (list ?? [])
          .map(item => item[key])
          .filter(value =>
            typeof value === "string" &&
            !R.isEmpty(value.trim()));
    }

    showBarcodeError = (data) => {
        const barcodeBooked = [
            data.ksuBarcode,
            data.giftBarcode,
            data.otherBarcode,
            data.partBarcode,
        ].some(barcodes => (barcodes?.length ?? 0) > 0);
        if (barcodeBooked) this.handleAlertBarcodeUsed(true, data);
        return barcodeBooked;
    }

    handleAlertBarcodeUsed = (visible, data) => {
        const barcode = {
            ksuBarcode: data?.ksuBarcode ?? [],
            giftBarcode: data?.giftBarcode ?? [],
            otherBarcode: data?.otherBarcode ?? [],
            partBarcode: data?.partBarcode ?? [],
        };
        this.setState(prevState => ({
            barcodeUsed: {
                ...prevState.barcodeUsed,
                visible: visible,
                ...barcode,
            },
        }));
    }

    handleAlertModalSaveVisibility = () => {
        this.setState((prevState) => ({
          ...prevState,
          alertModalSaveVisible: !prevState.alertModalSaveVisible,
        }));
    };

    onChangeValue = (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                [name]: value,
            }
        }))
    };

    handleConfirmTolakVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            confirmTolakVisible: !prevState.confirmTolakVisible
        }))
    }

    handleChangeValueScanner = (tab, value) => {
        this.setState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                [tab]: value,
            }
        }))
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    renderAlertBarcodeUsed = () => {
      let { ksuBarcode, giftBarcode, otherBarcode, partBarcode, visible} = this.state.barcodeUsed;
      return (
        <SimpleAlert
          title={"Informasi"}
          visible={visible}
          content={
              <div style={{textAlign:'left'}}>
                <p style={{marginBottom:'10px'}}>Barcode di bawah sudah di pakai.</p>
                {!R.isNil(ksuBarcode) && ksuBarcode.length > 0 && (
                <>
                  <p style={{marginBottom:'5px'}}>QR Code KSU: </p>
                  <FlexView style={{gap:'10px', maxHeight: "200px", overflowY: "auto", marginBottom:'10px'}}>
                    <ul
                      style={{
                        listStyleType: 'circle',
                        paddingLeft: '20px'
                      }}
                    >
                      {ksuBarcode.map(item=> <li key={item}>{item}</li>)}
                    </ul>
                  </FlexView>
                </>)}
                {!R.isNil(giftBarcode) && giftBarcode.length > 0 && (
                  <>
                    <p style={{marginBottom:'5px'}}>QR Code Hadiah: </p>
                    <FlexView style={{gap:'10px', maxHeight: "200px", overflowY: "auto", marginBottom:'10px'}}>
                      <ul
                        style={{
                          listStyleType: 'circle',
                          paddingLeft: '20px'
                        }}
                      >
                        {giftBarcode.map(item=> <li key={item}>{item}</li>)}
                      </ul>
                    </FlexView>
                  </>)}
                {!R.isNil(otherBarcode) && otherBarcode.length > 0 && (
                  <>
                    <p style={{marginBottom:'5px'}}>QR Code Barang Lain: </p>
                    <FlexView style={{gap:'10px', maxHeight: "200px", overflowY: "auto", marginBottom:'10px'}}>
                      <ul
                        style={{
                          listStyleType: 'circle',
                          paddingLeft: '20px'
                        }}
                      >
                        {otherBarcode.map(item=> <li key={item}>{item}</li>)}
                      </ul>
                    </FlexView>
                  </>)}
                {!R.isNil(partBarcode) && partBarcode.length > 0 && (
                  <>
                    <p style={{marginBottom:'5px'}}>QR Code Part: </p>
                    <FlexView style={{gap:'10px', maxHeight: "200px", overflowY: "auto", marginBottom:'10px'}}>
                      <ul
                        style={{
                          listStyleType: 'circle',
                          paddingLeft: '20px'
                        }}
                      >
                        {partBarcode.map(item=> <li key={item}>{item}</li>)}
                      </ul>
                    </FlexView>
                  </>)}
                <p style={{marginTop:'10px'}}>Silakan cek kembali.</p>
            </div>
          }
          onClickClose={() => this.handleAlertBarcodeUsed(false)}
          additionalButtons={(<SimpleButton onClick={() => this.handleAlertBarcodeUsed(false)}>OK</SimpleButton>)}
        />
      )
    };

    render() {
        return (
            <>
                <SimpleModal
                    title="PRE DELIVERY INSPECTION"
                    visible={!!this.props.id}
                    onClickClose={() => this.props.onClickClose("")}
                    content={
                        <ModalContainer>
                            <div className="grid grid-3x grid-mobile-none gap-15px">
                                <div id="grid-1">
                                    <SimpleInput
                                        id="input_text_cabang"
                                        readOnly
                                        name="cabang"
                                        label="Cabang"
                                        value={this.state.data?.cabang?.namaDealer}
                                    />
                                    <SimpleInput
                                        id="input_text_no_pdi"
                                        readOnly
                                        name="noPDI"
                                        label="No. PDI"
                                        value={this.state.data?.pdiNo}
                                    />
                                    <SimpleInput
                                        id="input_text_tipe_unit"
                                        readOnly
                                        name="tipeUnit"
                                        label="Tipe Unit"
                                        value={this.state.data?.type.typeName}
                                    />
                                </div>
                                <div id="grid-2">
                                    <SimpleInput
                                        id="input_text_warna_unit"
                                        readOnly
                                        name="warnaUnit"
                                        label="Warna Unit"
                                        value={this.state.data?.warna.namaWarnaKomersil}
                                    />
                                    <SimpleInput
                                        id="input_text_no_mesin"
                                        readOnly
                                        name="noMesin"
                                        label="No. Mesin"
                                        value={this.state.data?.engineNumber}
                                    />
                                    <SimpleInput
                                        id="input_text_no_rangka"
                                        readOnly
                                        name="noRangka"
                                        label="No. Rangka"
                                        value={this.state.data?.frameNumber}
                                    />
                                </div>
                                <div id="grid-3">
                                    <SimpleInput
                                        id="input_text_no_fj"
                                        readOnly
                                        name="noFJ"
                                        label="No. FJ"
                                        value={this.state.data?.salesFakturNo}
                                    />
                                    <SimpleInput
                                        id="input_text_keterangan"
                                        readOnly
                                        name="keterangan"
                                        label="Keterangan"
                                        value={this.state.data?.pdiNote}
                                    />
                                </div>
                            </div>
                            <Tabs>
                                <TabList>
                                    <Tab>Cek Fisik Unit</Tab>
                                    <Tab>KSU</Tab>
                                    <Tab>Hadiah</Tab>
                                    <Tab>Barang Lain</Tab>
                                    <Tab>Part</Tab>
                                    <Tab>Foto</Tab>
                                </TabList>
                                <TabPanel>
                                    <CekFisikUnitTab
                                        done={this.props.done}
                                        data={this.state.data?.physicalCheck}
                                        onChange={this.handleChangePhysical}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <KsuTab
                                        done={this.props.done}
                                        data={this.state.data?.ksu}
                                        kodeCabang={this.props.kodeCabang}
                                        onChangeValueScanner={this.handleChangeValueScanner}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <HadiahTab
                                        done={this.props.done}
                                        onChangeStatus={this.handleChangeTableStatus}
                                        data={{
                                            gift: this.state.data?.gift,
                                            giftBarcode: this.state.data?.giftBarcode,
                                        }}
                                        kodeCabang={this.props.kodeCabang}
                                        onChangeValueScanner={this.handleChangeValueScanner}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <BarangLainTab
                                        done={this.props.done}
                                        onChangeStatus={this.handleChangeTableStatus}
                                        data={{
                                            otherItem: this.state.data?.otherItem,
                                            otherItemBarcode: this.state.data?.otherItemBarcode,
                                        }}
                                        kodeCabang={this.props.kodeCabang}
                                        onChangeValueScanner={this.handleChangeValueScanner}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <PartTab
                                        done={this.props.done}
                                        onChangeStatus={this.handleChangeTableStatus}
                                        data={{
                                            part: this.state.data?.part,
                                            partBarcode: this.state.data?.partBarcode,
                                        }}
                                        kodeCabang={this.props.kodeCabang}
                                        onChangeValueScanner={this.handleChangeValueScanner}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <FotoTab
                                        done={this.props.done}
                                        showErrors={this.state.showErrors}
                                        data={{
                                            engineNumberPhoto: this.state.data?.engineNumberPhoto,
                                            frameNumberPhoto: this.state.data?.frameNumberPhoto,
                                        }}
                                        onChange={this.handleChangeImage}
                                    />
                                </TabPanel>
                            </Tabs>
                            {!this.props.done && (
                                <FlexView hAlignContent="right" style={{marginTop: "15px"}}>
                                    <SimpleButton onClick={this.handleRefresh}>Refresh</SimpleButton>
                                    <SimpleButton onClick={() => this.handleUpdateStatus(PDIStatus.PROSES)}
                                                  disabled={!this.props.userAccess?.updateAccess}>
                                        Simpan
                                    </SimpleButton>
                                    <SimpleButton onClick={() => this.handleConfirmTolakVisibility()}
                                                  disabled={!this.props.userAccess?.updateAccess}>
                                        Tolak
                                    </SimpleButton>
                                    <SimpleButton onClick={() => this.handleUpdateStatus(PDIStatus.SELESAI)}
                                                  disabled={!this.props.userAccess?.updateAccess}>
                                        Proses
                                    </SimpleButton>
                                </FlexView>
                            )}
                        </ModalContainer>
                    }
                />
                {this.state.confirmTolakVisible && (
                    <SimpleModal
                        visible={this.state.confirmTolakVisible}
                        title={"Alasan Tolak"}
                        onClickClose={this.handleConfirmTolakVisibility}
                        content={
                            <ModalContainer>
                                <SimpleTextArea
                                    id="input_text_area_alasan_tolak"
                                    name="pdiNote"
                                    value={this.state.data.pdiNote}
                                    onChange={(e) => this.onChangeValue(e.target.name, e.target.value)}
                                />
                                <FlexView hAlignContent="center">
                                    <SimpleButton
                                        className="margin-top-15px"
                                        text="Simpan"
                                        onClick={() => this.handleUpdateStatus(PDIStatus.TOLAK)}
                                    />
                                </FlexView>
                            </ModalContainer>
                        }
                    />
                )}

                 {this.state.alertModalSaveVisible && (
                  <SimpleAlert
                    title={"Peringatan!"}
                    content={"Terdapat data yang belum lengkap, mohon periksa kembali"}
                    visible={this.state.alertModalSaveVisible}
                    onClickClose={this.handleAlertModalSaveVisibility}
                    additionalButtons={
                      <FlexView>
                        <SimpleButton
                          type="button"
                          text="OK"
                          onClick={() => this.handleAlertModalSaveVisibility()}
                        />
                      </FlexView>
                    }
                  />
                )}
                {this.renderAlertBarcodeUsed()}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(FormDetailPDI);
